import axios from "axios";
import {useStore} from "@/state/store";

export function getApiUrl() {
	if((process.env?.VUE_APP_API_URL ?? null)) return process.env.VUE_APP_API_URL;

	// let port = process.env?.VUE_APP_IS_DEV === '1' ? ':8000' : ''
	// return `${window.location.protocol}//${window.location.hostname}${port}` + '/api/'
	return `${window.location.protocol}//${window.location.hostname}/api/`
}

const API_URL = getApiUrl()

export async function loginQuery(login, password, router = null) {
	let store = useStore()
	clearUser(store).finally(_ => {
		axios.post(`${API_URL}users/login`, {login, password})
			.then(resp => {
				store.setP('access_token', resp?.data.access_token)
				store.setP('refresh_token', resp?.data.refresh_token)
				axios.defaults.headers.common['Authorization'] = `Bearer ${resp?.data.access_token}`
				updateMe(store).finally(() => router.push("/"))
			})
			.catch(r => {
				store.addMessage(r?.response?.data?.detail ?? "Сетевая ошибка")
			})
	})
}

export async function clearUser(store) {
	// store.deleteP('access_token')
	// store.deleteP('refresh_token')
	// store.deleteP('user')
	store.resetStore()

	delete axios.defaults.headers.common['Authorization']
}

export async function updateMe(store, force=false) {
	const now = Date.now()
	let ret = {}
	const user = store.getP('user')

	if(force || !user || !user?.fetched_at || (now - user?.fetched_at) > 180000) {
		const r = await new Back(`${API_URL}users/me`, 'get').run()
		if(r?.data?.login) {
			ret = {...r?.data, fetched_at: now}
			store.setP('user', ret)
		}
		else if(store.getP('access_token')) {
			await clearUser(store)
		}
	}

	return ret
}

export async function logout(silent = false) {
	let store = useStore()
	await clearUser(store)
	if (!silent) window.dispatchEvent(new Event('session-expired'))
	window.location.href = '/login';
}

export async function isAuthenticated(store = null, role=null) {
	// используется только в роутере, во вьюхах/компонетантах только store.getP('user')
	if(!store) store = useStore()
	const has_access_token = !!store.getP('access_token')
	if(!has_access_token) return false

	let user = store.getP('user')
	await updateMe(store)
	if(!user) return false
	if(role && user?.role !== role) {
		store.addMessage('Доступ запрещен!')
		await clearUser(store)
		return false;
	}

	return has_access_token
}


export class Back {
	constructor(endpoint, method = "get") {
		this.store = useStore()
		this.endpoint = endpoint
		this.data = null
		this.method = method
		this.loading_key = `${endpoint}_${Math.random().toString(36).slice(2)}`
		this.show_error_message = true;
		this.controller = new AbortController()
	}

	setData(data) {
		this.data = data
		return this
	}

	setLoadingKey(loading_key) {
		this.loading_key = loading_key
		return this
	}

	 abort() {
	  this.controller.abort()
	 }

	run(callback = null) {
		this.store.setLoading(this.loading_key)

		let isRefreshing = false;
		let failedQueue = [];

		let api = axios.create({
			baseURL: API_URL,
  			headers: { 'Content-Type': 'application/json' },
		})

		const processQueue = (error, token = null) => {
			failedQueue.forEach(prom => {
				error ? prom.reject(error) : prom.resolve(token);
			});
			failedQueue = [];
		}

		// Передаю access_token
		api.interceptors.request.use(config => {
			const token = this.store.getP('access_token');
			if (token)  config.headers['Authorization'] = 'Bearer ' + token;
			return config;
		});

		// перехват 401 и удаление токенов и обновление access token
		api.interceptors.response.use(
			response => {
				this.store.setLoaded(this.loading_key)
				return response
			},

			async error => {
				const originalRequest = error.config;

				// todo: как то криво и не красиво все !!!!!
				if (
					error?.response &&
					[400, 403, 404, 503, 500].includes(error.response?.status)
				) {
					if(this.show_error_message) this.store.addMessage(error.response?.data?.detail)
					isRefreshing = false;
					this.store.setLoaded(this.loading_key)

					return Promise.resolve(error);
				}

				// Если ошибка 401 и не повторяемая
				else if (
					error?.response &&
					error.response?.status === 401 &&
					!originalRequest._retry
				) {
					if (isRefreshing) {

						// Ждём обновление
						return new Promise(function (resolve, reject) {
							failedQueue.push({resolve, reject});
						})
							.then(token => {
								originalRequest.headers['Authorization'] = 'Bearer ' + token;
								return api(originalRequest);
							})
							.catch(err => {
								return Promise.reject(err);
							})
							.finally(_ => {
								this.store.setLoaded(this.loading_key)
							})
					}

					originalRequest._retry = true;
					isRefreshing = true;

					try {
						const refreshToken = this.store.getP('refresh_token');

						const res = await axios.post(`${API_URL}users/refresh`, {
							token: refreshToken,
						});

						const newAccessToken = res.data.access_token;
						this.store.setP('access_token', newAccessToken);
						api.defaults.headers.common['Authorization'] = 'Bearer ' + newAccessToken;
						processQueue(null, newAccessToken);

						originalRequest.headers['Authorization'] = 'Bearer ' + newAccessToken;
						return api(originalRequest);

					} catch (err) {
						processQueue(err, null);
						this.store.deleteP('access_token');
						this.store.deleteP('refresh_token');
						window.location.href = '/login'; // или emit logout
						return Promise.reject(err);
					} finally {
						isRefreshing = false;
					}
				}

				if (error?.response) {

					let msg = `Error ${error} ${error.response?.status} ${error.response?.message}`
					this.store.addMessage(msg)
				}
				else if(error?.message) {
					if (error.name === 'CanceledError') {
						this.store.setLoaded(this.loading_key)
						return
					}

					let msg = `Error ${error?.message}`
					this.store.addMessage(msg)
				}

				this.store.setLoaded(this.loading_key)
				return callback ? callback(error) : Promise.reject(error);
			}
		)

		// нужно передать только эндпоинт
		let args = {
			url: this.endpoint.startsWith(API_URL) ? this.endpoint : `${API_URL}${this.endpoint}`,
			method: this.method,
			signal: this.controller.signal,
		}

		// Чтобы не запрашивать null
		let data = this.data ? {...this.data} : {} // чтобы при чистке null не реактивить
		// данные
		for (let k in data) {
			if (data[k] === null) delete data[k]
			if (data[k] === 'null') data[k] = null // чтобы сбрасывать значения
		}
		args[this.method === 'get' ? 'params' : 'data'] = data

		// универсальный запрос
		try {
			let promise = api.request(args)
			let chain = promise.then(r => {
				if(r?.data?.alert && this.store) this.store.addMessage(r?.data?.alert)
				return r // пробрасываем дальше
			})

			return callback ? chain.then(callback) : chain
		} catch (error) {
			return callback ? Promise.reject(error).then(callback) : Promise.reject(error)
		}

	}
}